import React from 'react';

import { useParams } from 'react-router';

import { Grid } from '@mui/material';
import { FormikHelpers, FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { initialTagValues, TradeTag } from 'pages/marketing-trade/trade/tag/types';

export function TradeTagFormComp() {
    const { setContent } = useFormContext();
    const url = '/gestao/tagpecatrade';
    const { id } = useParams();
    const { mutate } = useFormMutation();

    const handleSubmit = (values: TradeTag, formik: FormikHelpers<TradeTag>): void => {
        mutate(
            {
                url,
                idField: 'idTagPecaTrade',
                formData: values,
                formik,
            },
            {
                onSuccess: (response: any) => {
                    const { data } = response.data;

                    if (data) {
                        setContent(data);
                    }
                },
            },
        );
    };

    const validationSchema = Yup.object({
        dsTagPecaTrade: Yup.string().required(),
    });

    return (
        <FormPage title="Tags Trade" values={initialTagValues} onSubmit={handleSubmit} url={url} validationSchema={validationSchema} goBackButton>
            {(formik: FormikProps<TradeTag>) => {
                return (
                    <Block>
                        <Row>
                            {id && (
                                <Grid sx={{ flex: 1 }}>
                                    <CissTextField label="Código" name="idTagPecaTrade" value={id} disabled={true} />
                                </Grid>
                            )}

                            <Grid sx={{ flex: 4 }}>
                                <CissTextField
                                    label="Tag"
                                    name="dsTagPecaTrade"
                                    value={formik.values.dsTagPecaTrade}
                                    error={formik.errors.dsTagPecaTrade}
                                    onChange={(e) => formik.setFieldValue('dsTagPecaTrade', e.target.value)}
                                />
                            </Grid>
                        </Row>
                    </Block>
                );
            }}
        </FormPage>
    );
}
